import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getACampaign } from 'src/common/Scraper';
import { Campaign, CampaignDetails } from '../types';

const QUERY_KEY = 'getACampaignDetails';
const DEFAULT_REFETCH_INTERVAL = 10 * 1000; // 10 seconds

interface IGetACampaignDetailsProps {
  campaignId?: string;
  refetchInterval?: number;
  refetch?: boolean;
}

interface GetACampaignData {
  status: string;
  message: string;
  response: CampaignDetails;
}

type GetACampaignResponse = AxiosResponse<GetACampaignData>;

export const useGetACampaignDetails = ({
  campaignId,
  refetchInterval,
  refetch
}: IGetACampaignDetailsProps): UseQueryResult<GetACampaignResponse, Error> => {
  return useQuery<GetACampaignResponse, Error>({
    queryKey: [QUERY_KEY, campaignId],
    queryFn: () =>
      getACampaign({
        campaign_id: parseInt(campaignId!)
      }) as Promise<GetACampaignResponse>,
    enabled: !!campaignId,
    refetchInterval: refetch
      ? refetchInterval || DEFAULT_REFETCH_INTERVAL
      : false,
  });
};
